module.exports = __webpack_public_path__ + "./img-zaou_3910428c33c319af59283715e4772d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-zaou.png
// module id = 450
// module chunks = 0